import React from 'react';

import { BaseIconProps } from './icon-types';

export const Pen = ({ fill }: BaseIconProps) => (
  <path
    d="M 881.67405,255.0354 837.44382,309.05428 694.23941,190.32151 738.46964,136.12135 A 93.082863,93.082863 0 0 1 881.67405,255.0354 Z M 328.43372,926.8272 179.88181,963.35343 186.67947,809.18208 637.50147,260.111 780.70588,378.84377 Z M 925.36047,55.636854 A 181.5433,181.5433 0 0 0 669.58651,80.924215 L 107.10134,764.31741 A 43.051959,43.051959 0 0 0 96.950137,790.78303 L 86.889574,1018.913 a 44.592767,44.592767 0 0 0 45.771036,46.4055 39.879709,39.879709 0 0 0 10.33247,0 l 222.32937,-54.3815 a 43.051959,43.051959 0 0 0 23.65591,-14.86419 L 951.82604,312.6797 A 181.81522,181.81522 0 0 0 926.44806,56.543212 Z"
    fill={fill}
    strokeWidth={99.9312}
  />
);
